module.exports = __webpack_public_path__ + "media/10-1.4cf47364.mp3";